module.exports = __webpack_public_path__ + "img/Groups.3514f3ce.svg";